export default "__VITE_ASSET__CvYGpomO__"